<juridico-header></juridico-header>
  <main id="main">
    <div class="d-flex align-items-center justify-content-center contato-concluido mt-5 pt-5" style="min-height: 500px;">
        <div class="p-nav mt-5 pt-5 text-center">
            <h1 class="mt-5"><strong>Processo concluído!</strong></h1>
            <p class="lead">
                Sua inscrição para o recebimento de <strong>{{ frase }}</strong> por e-mail foi removida com sucesso!
            </p>
            <p class="lead">
                As demais notificações importantes do sistema continuaram a ser enviadas para o seu e-mail.
            </p>
            <p class="lead">
                Clique em <strong>Continuar</strong> para retornar a homepage!
            </p>
            <p class="lead">
                <small>Ou aguarde 5 segundos para ser redirecionado.</small>
            </p>
            <p class="text-center mt-3">
                <a href="/" [routerLink]="['/']" title="Continuar" class="">
                    <button class="button">Continuar</button>
                </a>
            </p>
        </div>
    </div>
  </main>
<juridico-footer></juridico-footer>